import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import classNames from 'classnames';
import {DashboardLayout} from './layout/DashboardLayout';
import {MainView} from '../main/components/MainView/MainView';
import {NotificationModal} from '../../../components/notification-modal/component';
import {SurveyModal} from '../../../modals/survey-modal/SurveyModal.component';
import {TimeoutDialog} from '../../../components/timeout-dialog/TimoutDialog.component';
import {ThankYouModal} from '../../../modals/thank-you-modal/ThankYouModal.component';
import {ClientTimeoutDialogModal} from '../../../modals/client-timeout-dialog/ClientTimeoutDialog.component';
import {EndMeetingModal} from '../../../modals/end-meeting-modal/EndMeetingModal.component';
import {ErrorDialog} from '../../../components/error-dialog/ErrorDialog.component';
import {DashboardGuidance} from '../dashboard-guidance/component';
import {SimpleModal} from '../../../components/simple-modal/component';
import {FallbackModeModal} from '../../../components/fallback-mode/component';
import {ConnectivityIssuePopup} from '../../../components/connectivity-issue-popup/component';
import {ModeSwitchModal} from '../../../components/mode-switch-confirmation-modal/component';
import {LoginModal} from '../../login/components/login-modal/component';

import './DashboardNewView.scss';
import {ScreenLoader} from '../../../components/screen-loader/screen-loader';

export interface IDashboardNewViewProps {
    dashboard: any;
}

@observer
export class DashboardNewView extends TechseeBaseComponent<IDashboardNewViewProps> {
    renderInternal(): JSX.Element {
        const {dashboard} = this.props;
        const dashboardState = dashboard?.dashboardState;

        if (
            !dashboardState?.dashboardControllerLoaded ||
            dashboard.simpleAPIMode ||
            !dashboard.tsInterfaceHelper?.useNewInterface ||
            dashboard.miniDashboard
        ) {
            return <React.Fragment />;
        }

        return (
            <div
                className={classNames('dashboard-container ts-horizontal-layout bright-dashboard', {
                    isIE: dashboard.isIE
                })}>
                {/* Modals */}
                {dashboard.fallbackModeNotification && dashboard.fallbackModeController && (
                    <FallbackModeModal controller={dashboard.fallbackModeController} />
                )}

                {dashboard.connectivityIssuePopupController && (
                    <ConnectivityIssuePopup controller={dashboard.connectivityIssuePopupController} />
                )}

                {dashboard.customerEndedTheMeetingModalCtrl && (
                    <SimpleModal ctrl={dashboard.customerEndedTheMeetingModalCtrl} />
                )}

                {dashboard.simpleModalCtrl && <SimpleModal ctrl={dashboard.simpleModalCtrl} />}

                {dashboard.notificationCtrl && <NotificationModal ctrl={dashboard.notificationCtrl} />}

                {dashboard.errorDialogController && <ErrorDialog ctrl={dashboard.errorDialogController} />}

                {dashboard.surveyModalController && <SurveyModal ctrl={dashboard.surveyModalController} />}

                {dashboard.timeoutDialogController && <TimeoutDialog ctrl={dashboard.timeoutDialogController} />}

                {dashboard.thankYouModalController && <ThankYouModal ctrl={dashboard.thankYouModalController} />}

                {dashboard.clientTimeoutDialogCtrl && (
                    <ClientTimeoutDialogModal ctrl={dashboard.clientTimeoutDialogCtrl} />
                )}

                {dashboard.endMeetingModalController && <EndMeetingModal ctrl={dashboard.endMeetingModalController} />}

                {dashboard.modeSwitchModalController && (
                    <ModeSwitchModal controller={dashboard.modeSwitchModalController} />
                )}

                {dashboard.dashboardGuidanceController && (
                    <DashboardGuidance controller={dashboard.dashboardGuidanceController} />
                )}

                {dashboard.enableReloginOnSessionExpired && dashboard.loginModalController && (
                    <LoginModal controller={dashboard.loginModalController} />
                )}

                {/* Main Area */}
                <DashboardLayout>
                    <MainView main={dashboard} />
                </DashboardLayout>
                {!dashboardState.mainLoaded && <ScreenLoader />}
            </div>
        );
    }
}
